import { logSomething } from './module';
import { toggle } from './toggle';
import { navigation } from './navigation';
import { mqCheck } from './mq';
import { clickableCards } from './clickableCards';
import { statistics } from './statistics.js';
import { calculations } from './calculations.js';
import { filter } from './filter.js';
import { videoplayer } from './videoplayer.js';
import { forms } from './forms.js';
import { print } from './print.js';
import { reset } from './resetForm.js';
import { search } from './searchForm.js';
import { todo } from './todo.js';
import { newsletter } from './newsletter.js';
import { formValidation } from './formValidation.js'
import { changeCompany } from './changeCompany.js';
import { kpi } from './kpi.js';
import { campaignVideo } from './campaignVideo.js';
import { subscriptions } from "./subscriptions.js";
import { toggleProperty } from "./toggleProperty.js";
import { dialog } from "./dialog.js";
import { reCaptcha } from './reCaptcha.js';
import { activitiesSwiper } from './activitiesSwiper.js';
import { newsListSwiper } from './newsListSwiper.js';
import { newsloader } from './newsloader.js';
import { sideMenu } from './sideMenu.js';
import { downloadListSwiper } from './downloadListSwiper.js';
import { articleListSwiper } from './articleListSwiper.js';
import { hero } from './hero.js';
import { toc } from './toc.js';
